import { handleActions } from 'redux-actions';

import { LOADER_ACTIONS, STATUS } from '../constants';

const initialState = {};

const setActive = (state) => ({
	...state,
	status: STATUS.active,
});

const setInactive = (state) => ({
	...state,
	status: STATUS.inactive,
});

export default handleActions(
	{
		[LOADER_ACTIONS.set_loader_active]: setActive,
		[LOADER_ACTIONS.set_loader_inactive]: setInactive,
	},
	initialState,
);
